import { Component, OnInit } from '@angular/core';
import { ClaimRow } from '../../../../../models/api/view/claim-view/claim-row';
import { getClaimKey } from '../../../../../functions/get-claim-key';
import {
  PropertyResponse,
  StatementOfLossInfo,
} from '../../../../../models/api/view/claim/details/property/property-response';
import { BaseComponent } from '../../../../base/base.component';
import { DetailItemComponent } from '../../../../core/panels/detail-panel/detail-item.component';
import { DetailPanelComponent } from '../../../../core/panels/detail-panel/detail-panel.component';

@Component({
  selector: 'app-loss-statement-pr',
  imports: [DetailPanelComponent, DetailItemComponent],
  template: `
    <div class="tw-flex tw-w-full tw-gap-12 tw-py-8">
      <app-detail-panel [dataSource]="statementOfLoss" class="tw-basis-1/3">
        <app-detail-item
          label="total gross loss"
          name="totalGrossLoss"
          format="c"
        />
        <app-detail-item
          label="depreciation amount"
          name="depreciationAmount"
          format="c"
        />
        <app-detail-item
          label="actual cash value"
          name="actualCashValue"
          format="c"
        />
        <app-detail-item
          label="co-insurance penalty"
          name="coInsurancePenalty"
          format="c"
        />
        <app-detail-item
          label="deductible amount"
          name="deductibleAmount"
          format="c"
        />
      </app-detail-panel>

      <app-detail-panel [dataSource]="statementOfLoss" class="tw-basis-1/3">
        <app-detail-item
          label="covered loss amount"
          name="coveredLossAmount"
          format="c"
        />
        <app-detail-item
          label="replacement cost"
          name="replacementCost"
          format="c"
        />
        <app-detail-item
          label="co-insurance percentage"
          name="coInsurancePercentage"
          format="%"
        />
        <app-detail-item
          label="amount insurance required"
          name="amountInsuranceRequired"
          format="c"
        />
        <app-detail-item
          label="amount insurance carried"
          name="amountInsuranceCarried"
          format="c"
        />
      </app-detail-panel>
    </div>
  `,
  styles: `
    .row div {
      height: 20px;
    }
  `,
})
export class LossStatementPrComponent extends BaseComponent implements OnInit {
  claimRow: ClaimRow;
  propertyResponse: PropertyResponse;
  statementOfLoss: StatementOfLossInfo;

  async ngOnInit(): Promise<void> {
    this.view.showLoading();

    const claimKey = getClaimKey();
    if (claimKey) {
      this.propertyResponse = await this.api.property.get(claimKey);
      this.statementOfLoss = this.propertyResponse.statementOfLoss;
    }

    this.claimRow = this.view.currentClaim();
    this.view.hideLoading();
  }
}
